import React from "react";

interface Props {
  tableHeader: any[];
  extraHeader?: boolean;
  textCenter?: boolean;
}
const GroupingTableHeader = ({
  tableHeader = [],
  extraHeader,
  textCenter,
}: Props) => {
  return (
    <tr>
      {tableHeader.map((item, index) => {
        if (item) {
          return (
            <th
              className={`${textCenter ? "text-center" : null}`}
              key={item?.value}
              style={{
                width:
                  item?.value === "account_name" ||
                  item?.value === "ledger_name"
                    ? "75%"
                    : "25%",
              }}
            >
              {item?.label}
            </th>
          );
        } else {
          return null;
        }
      })}
      {extraHeader && <th></th>}
    </tr>
  );
};

export default GroupingTableHeader;
